var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"min-height":"calc(100vh - 150px)"}},[_c('FolderList',{attrs:{"resources":_vm.resources,"loading":_vm.loading,"wide":!_vm.isPhoneBool}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }